import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import environment from "./environment";
import { Analytics, getAnalytics, isSupported } from "firebase/analytics";

export enum CollectionPath {
	PROJECTS = "projects",
	PROFILES = "profiles",
	PROFILE_LIMITS = "profileLimits",
	COMPANIES = "companies",
	COMPANY_SETTINGS = "companySettings",
	SCHEDULES = "schedules",
	SCHEDULE_RESOURCES = "resources",
	SCHEDULE_ENTRIES = "entries",
	SCHEDULE_PHASES = "phases",
	SCHEDULE_ENTRY_TYPES = "entryTypes",
}

export const app = initializeApp(environment.firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export let analytics: Analytics | undefined = undefined;

void (async () => {
	if (environment.env !== "production") return;
	const isAnalyticsSupported = await isSupported();
	if (!isAnalyticsSupported) return;
	analytics = getAnalytics(app);
})();
